/* eslint max-lines: ["error", 500] */
import '../lib/common/design-select';
import Vue from 'vue';
import VueForm from 'vue-form';
import VueScrollTo from 'vue-scrollto';
import VueRecaptcha from 'vue-recaptcha';
import formSubmissionMixin from './mixins/form-submission';
import validationMixin from './mixins/validation';

Vue.use(VueForm);
Vue.use(VueScrollTo, { offset: -20 });

const RWLEAD_ID = 'rwleadsl-app';
const rwLeadSl = document.getElementById(RWLEAD_ID);

if (rwLeadSl) {
	new Vue({
		name: 'RWLEADSL',
		components: {
			VueRecaptcha
		},
		mixins: [formSubmissionMixin, validationMixin],
		data() {
			return {
				submited: false,
				submitError: false,
				isSubmitting: false,
				formState: {},
				token: null,
				requiredGroupInvalid: true,
				model: {}
			};
		},
		created() {
			this.model = JSON.parse(JSON.stringify(window.rwleadSlFormModel));
		}
	}).$mount(rwLeadSl);
}
